import React from 'react';
import { HybridIcon } from './HybridIcon';
import './FormInput.css';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  required?: boolean;
  error?: string;
  hint?: string;
  icon?: string;
}

export function FormInput({ 
  label, 
  required = false, 
  error, 
  hint, 
  className,
  icon,
  ...props 
}: FormInputProps) {
  return (
    <div className="form-input-container">
      <div className="form-input-label-container">
        <label className="form-input-label">
          {label}
          {required && <span className="form-input-required"> *</span>}
        </label>
        {hint && <span className="form-input-hint">{hint}</span>}
      </div>
      <div className="form-input-wrapper">
        {icon && (
          <div className="form-input-icon">
            <HybridIcon name={icon} size={16} color="var(--ink-3)" />
          </div>
        )}
        <input
          className={`form-input ${icon ? 'form-input-with-icon' : ''} ${error ? 'form-input-error' : ''} ${className || ''}`}
          {...props}
        />
      </div>
      {error && (
        <div className="form-input-error-container">
          <span className="form-input-error-text">⚠️ {error}</span>
        </div>
      )}
    </div>
  );
}
